import type { FC } from 'react';
import React from 'react';

import type { CaptionData, NodeStyle } from './../../ricos-schema/legacy/wix/rich_content/v1';
import type { NodeViewRenderer, NodeViewRendererProps } from './../../ricos-types';

import { captionDefaultAttributes } from './consts';
import classes from './viewer-caption.rtlignore-scss';

export const ViewerCaption: FC<NodeViewRendererProps> = ({
  node,
  nodeIndex,
  NodeViewContainer,
  RicosNodesRenderer,
}) => {
  const { lineHeight, textAlignment: textAlign } = node.captionData?.textStyle || {};

  const nodeStyle: CaptionData & NodeStyle = {
    paddingTop: node.style?.paddingTop || captionDefaultAttributes.styleDefaults.paddingTop,
    paddingBottom:
      node.style?.paddingBottom || captionDefaultAttributes.styleDefaults.paddingBottom,
    ...(lineHeight && { lineHeight }),
    ...(textAlign && { textAlign }),
  };

  return node.nodes?.length ? (
    <NodeViewContainer node={node} nodeIndex={nodeIndex}>
      <figcaption className={classes.imageCaption} style={nodeStyle}>
        <RicosNodesRenderer nodes={node.nodes} shouldParagraphApplyTextStyle />
      </figcaption>
    </NodeViewContainer>
  ) : null;
};

const CaptionRenderer: NodeViewRenderer = props => {
  return <ViewerCaption key={props.node.id} {...props} />;
};

export default CaptionRenderer;
